module.exports = __webpack_public_path__ + "static/w-dxc-6078a4edc968b7ad1241b6c3a172b9ea.webp";